<template>
	<layout
		module-name="Cobranças"
		title="Emitir Cobrança"
	>
	<template #page>
		<div class="page-container">
			<div class="container">
				<section-title title="Emitir Cobrança" />
				<stepper :steps="['Dados da Cobrança', 'Divisão da Cobrança', 'Gerar Cobrança']" :currentStep="stepPage"/>
				<card-invoice>
					<div class="step-1" v-if="stepPage === 0">
						<div class="card-section">
							<span class="title-section">1. Negócio</span>
							<span class="description-section">Selecione uma negociação em andamento.</span>
							<ui-deal-selector
								v-model="form.deal"
								return-value="object"
								design="br-default"
								cancel-event="request-reserve"
								:disabled="cantSelectDeal"
								:is-iframe="iframe"
								:label="''"
							/>
						</div>
						<div class="card-divider"></div>
						<div class="card-section">
							<span class="title-section">2. Cobrança</span>
							<span class="description-section">Informe o tipo de cobrança e o valor que o cliente deverá pagar.</span>
							<div class="card-section-row-1">
								<div class="grid-inputs-3">
									<div>
										<ui-select-v2
											v-model="form.value"
											:data="selectOptions"
											:search="false"
											label="Tipo:"
											align="left"
											item-label="name"
											return-value="id"
											@input="skate"
										/>
									</div>
									<div>
										<ui-input-money
											v-model="form.money"
											label="Valor da Cobrança:"
											prefix=''
											class="money-input"
											group
										/>
									</div>
									<div>
									</div>
								</div>
								<ui-textarea-v2
									v-model="form.textarea"
									placeholder=""
									:message="`${remainingChars} caracteres restantes.`"
									label="Descrição:"
									class="textarea-input"
									rows="4"
									:maxlength="100"
								/>
							</div>
						</div>
						<div class="card-divider"></div>
						<div class="card-section">
							<span class="title-section">3. Prazo para Pagamento</span>
							<span class="description-section">Informe qual o prazo limite que o cliente poderá fazer o pagamento dessa cobrança.</span>
							<tag-choice
								v-model="selectedDate"
								:options="dateOptions"
								:spacing="7"
								@change="handleChange"
								type="alone"
							/>
							<div class="card-section-row-3">
								<div class="grid-inputs-3">
									<div class="date-picker-content">
										<ui-datepicker v-model="form.payday" :value="form.payday" :context="'today'" size="md" :label="'Data:'" class="date-picker-payment"/>
									</div>
									<div class="hour-picker-content">
										<hour-picker v-model="form.selectedTime" label="Horário:"/>
									</div>
									<div></div>
								</div>
							</div>
						</div>
					</div>
					<div class="step-2" v-if="stepPage === 1">
						<div class="card-section card-section-pix">
							<span class="title-section">Deseja dividir a cobraça em vários Pix?</span>
							<span class="description-section">Facilite o pagamento dividindo o valor total da cobrança em diferentes Pix.</span>
							<div class="card-quantity-pix">
								<div class="content-pix">
									<ui-input-number-stepper
										v-model="form.quantityPix"
										input-text-color="#172B46"
									/>
									<span class="description-pix">
										Informe a quantidade de PIX desejado.
									</span>
								</div>
							</div>
						</div>
						<div class="card-section">
							<span class="title-section title-section-pix">Quem vai pagar?</span>
							<span class="description-section">Informe os dados dos responsáveis pelos pagamentos dos Pix.</span>
							<div class="pix-cards">
								<pix-card
									v-for="(payment, index) in payments"
									:key="index+1"
									:pixLabel="'Pix ' + (index + 1)"
									:title="payment.title"
									:value="payment.value"
									:description="payment.description"
									:status="payment.status"
								/>
							</div>
						</div>
						<div class="card-section">
							<div class="message-validation">
								<span class="badge-icon">
									<ui-x-mark-icon />
								</span>
								<span class="message">{{ messageValidation }}</span>
							</div>
						</div>
					</div>
					<div class="step-3" v-if="stepPage === 2">
						<div class="card-section">
							<span class="title-section title-section-create-invoice">1. Informações do Cliente</span>
							<client-info-card
								:name="'Eduardo Gomes Pereira'"
								:unit="'Park House Residence'"
								:deal-id="4585"
								:deal-link="'/negocios/4585'"
								:whatsapp="'+55 (62)98197-1599'"
								:email="'eduardo.gomes@gmail.com'"
								:cpf="'111.193.837-45'"
								:avatars="[
									'https://randomuser.me/api/portraits/men/32.jpg',
									'https://randomuser.me/api/portraits/women/44.jpg'
								]"
							/>
						</div>
						<div class="card-section">
							<span class="title-section title-section-create-invoice">2. Informações da Cobrança</span>
							<div class="payment-summary">
								<div class="info-header">
									<div class="left-side">
										<div class="item-content">
											<span class="title">Tipo da cobrança:</span>
											<span class="description">Reserva Pix</span>
										</div>
										<div class="item-content">
											<span class="title">Valor:</span>
											<span class="description">R$ 500</span>
										</div>
										<div class="item-content">
											<span class="title">Quantidade de Pix:</span>
											<span class="description">02</span>
										</div>
									</div>
									<div class="right-side">
										<div class="item-content">
											<span class="title">Vencimento:</span>
											<span class="description">10/05/2025 às 10:00</span>
										</div>
										<div class="item-content">
											<span class="title">Responsável:</span>
											<span class="description">Glauco Farnezi</span>
										</div>
									</div>
								</div>
								<div class="pix-payment-info">
									<div class="pix-payment-item">
										<div class="pix-payment-left-content">
											<span class="pix-payment-badge">Pix 1</span>
											<span class="pix-payment-name">Pai do Eduardo</span>
										</div>
										<div class="pix-payment-centered-content">
											<span class="pix-payment-contact">
												<i class="fa-brands fa-whatsapp" style="color: #4caf50"></i>
												+55981971599
											</span>
										</div>
										<div class="pix-payment-right-content">
											<span class="pix-payment-value">R$ 3.000,00</span>
										</div>
									</div>

									<div class="pix-payment-item pix-payment-second">
										<div class="pix-payment-left-content">
											<span class="pix-payment-badge">Pix 2</span>
											<span class="pix-payment-name">Mãe do Eduardo</span>
										</div>
										<div class="pix-payment-centered-content">
											<span class="pix-payment-contact">
												<i class="fa-regular fa-envelope" style="color: #4caf50"></i>
												maria.pereira@gmail.com
											</span>
										</div>
										<div class="pix-payment-right-content">
											<span class="pix-payment-value">R$ 2.000,00</span>
										</div>
									</div>
								</div>
							</div>

						</div>
						<div class="card-section">
							<span class="title-section title-section-create-invoice">3. Reserva de Unidade</span>
							<div class="unit-card">
								<a href="#" class="unit-link">Park House Residence</a>
								<span class="unit-location">Lote 03 - Quadra 05</span>
								<span class="unit-price">300m² - R$ 257.450,00</span>
							</div>
						</div>
						<div class="card-section card-section-description">
							<span class="title-section title-section-create-invoice">4. Descrição da Cobrança</span>
							<div class="description-or-comment-invoice">
								Reserva de Unidade - Park House Residence - Quadra 03 - Lote 05
							</div>
						</div>
					</div>
				</card-invoice>
				<div class="page-observations">
					<h2 class="observations-description">Ao transferir uma reserva ela é será cancelada para o negócio de origem e logo após é realizado uma nova reserva para o negócio de destino.</h2>
				</div>
			</div>
		</div>
	</template>
	<template v-slot:footer>
		<div class="page-footer">
			<div class="buttons-row">
				<div class="buttons">
					<div class="draft-action">
						<span class="save-draft">
							Salvar cobrança como rascunho
						</span>
					</div>
					<ui-button design="md grey" class="back-button" v-if="stepPage > 0" @click="stepPage--">Voltar</ui-button>
					<ui-button design="md primary" class="next-button" @click="stepPage++" v-if="stepPage < 2">Avançar</ui-button>
					<ui-button design="md success" class="create-invoice" v-if="stepPage === 2">Gerar cobrança</ui-button>
				</div>
			</div>
		</div>
	</template>
</layout>
</template>

<script>
import layout from '@/templates/page-payments';
import sectionTitle from '@/components/ui-facilita/section-title';
import stepper from '@/components/ui-facilita/stepper';
import tagChoice from '@/components/ui-facilita/tag-choice';
import pixCard from './components/PixCard';
import cardInvoice from './components/CardInvoice';
import { uiDealSelector } from '@/components/ui-facilita/selectors';
import HourPicker from '@/components/ui-facilita/hour-picker';
import { uiButton } from "@/components/ui/buttons";
import { uiSelectV2, uiInputMoney, uiDatepicker, uiTextareaV2, uiInputNumberStepper } from '@/components/ui/form';
import { selectOptions } from '../configurations/util/functions';
import clientInfoCard from './components/ClientInfoCard';

export default {
	name: 'payments',
	components: {
		layout,
		sectionTitle,
		stepper,
		cardInvoice,
		uiDealSelector,	
		uiButton,
		uiSelectV2,
		uiInputMoney,
		uiDatepicker,
		uiTextareaV2,
		uiInputNumberStepper,
		pixCard,
		tagChoice,
		HourPicker,
		clientInfoCard
	},
	data() {
		return {
			iframe: false,
			stepPage: 0,
			cantSelectDeal: false,
			selectedDate : '',
			messageValidation: 'A quantidade e os valores do Pix não correspondem ao total de R$ 5.000 da cobrança.',
			payments:[
				{
					id: 1,
					pixLabel: 'Pix 1 - #45695',
					title: 'Pai do Eduardo',
					value: '3.000',
					description: 'Enviado para o whatsapp: +55981971555',
					status: 'paid',
					link: 'Comprovante'
				},
				{
					id: 2,
					pixLabel: 'Pix 2 - #45696',
					title: 'Mãe do Eduardo',
					value: '2.000',
					description: 'Enviado para o email: maria.pereira@gmail.com',
					status: 'pending',
					link: 'Reenviar Email',
					dueDate: '10/05/2025 às 15:00'
				}
			],
			dateOptions: [
				{ label: 'Hoje', value: '20/03/2025' },
				{ label: 'Amanhã', value: '21/03/2025' },
				{ label: 'Escolher Data', value: '' }
			],
			form: {
				deal: null,
				value: null,
				money: 1000,
				payday: '',
				selectedTime: '10:00',
				textarea: '',
				quantityPix: 1
			},
			selectOptions: [
				{
					id: 1,
					name: 'A Vista'
				},
				{
					id: 2,
					name: 'Parcelado'
				},
				{
					id: 3,
					name: 'Mensalidade'
				}
			],

		}
	},
	computed: {
		remainingChars() {
			return 100 - (this.form.textarea?.length || 0)
		},
		computedSvgPath(status) {
			switch (status) {
				case 'valid': {
					return 'A quantidade e os valores do Pix correspondem ao total de R$ 5.000 da cobrança.';
				}
				case 'invalid': {
					return 'A quantidade e os valores do Pix não correspondem ao total de R$ 5.000 da cobrança.';
				}
			}
		},
		computedSvgBackgroundColor(status) {
			switch (status) {
				case 'valid': {
					return '#5ac387';
				}
				case 'invalid': {
					return '#ff6675';
				}
			}
		},
		computedValidation(status) {
			switch (status) {
				case 'valid': {
					return 'success';
				}
				case 'invalid': {
					return 'error';
				}
			}
		}
	},
	methods: {
		skate() {
			console.log('skate')
		},
		handleChange(option) {
		console.log('Selecionado:', option)
		},
	},
	watch: {
		'form.deal'(oldValue, newValue) {
			console.log('old', oldValue);
			console.log('new', newValue);
		}
	}
}
</script>

<style lang="stylus" scoped>
@import './styles.styl'
</style>